import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import NavBarLogo from './NavBarLogo';
import { authenticationService } from '../../services';
import useAuth from '../../hooks/useAuth';
import { setLanguage } from '../../redux/slices/applicationSlice';
import { Language } from '../../types/requests';
import useLanguage from '../../hooks/useLanguage';

interface NavigationBarProps {
  handleLogin?: () => void;
}

function NavigationBar({ handleLogin }: NavigationBarProps): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lang = useLanguage();
  const auth = useAuth();

  return (
    <>
      <div className="mt-2 flex w-full md:mt-4">
        <div className="mx-4 my-2 flex w-full items-center justify-between md:mx-8 md:my-4 lg:mx-32">
          <NavBarLogo />
          <div className="flex items-center gap-2 md:gap-4">
            {handleLogin && !auth && (
              <p onClick={() => handleLogin?.()} className="cursor-pointer text-sm font-medium md:text-base">
                {t('general.logIn')}
              </p>
            )}
            {auth && (
              <p onClick={authenticationService.logOut} className="cursor-pointer text-sm font-medium md:text-base">
                {t('general.logOut')}
              </p>
            )}
            <button
              type="button"
              onClick={() => dispatch(setLanguage(lang === Language.NL ? Language.EN : Language.NL))}
              className="flex h-fit items-center gap-2 rounded-[20px] border border-primary-300 border-opacity-30 bg-secondary px-3 py-1.5 transition-all hover:border-opacity-100 hover:bg-primary-300 hover:bg-opacity-10 md:px-4 md:py-2"
              aria-label={`Switch to ${lang === Language.NL ? 'English' : 'Nederlands'}`}>
              <img
                src={`${process.env.PUBLIC_URL}/images/flags/${lang === Language.NL ? Language.EN : Language.NL}.svg`}
                alt={lang === Language.NL ? 'English' : 'Nederlands'}
                className="h-5 w-5 md:h-6 md:w-6"
              />
              <span className="text-xs font-medium text-primary-900 md:text-sm">
                {lang === Language.NL ? 'EN' : 'NL'}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavigationBar;
